import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    enviarUrl: String,
    revogarUrl: String,
    email: String
  }

  openEmail() {
    document.getElementById("modal_acompanhamento").showModal()
  }

  openWhatsapp() {
    document.getElementById("modal_acompanhamento_whatsapp").showModal()
  }

  async enviarEmail() {
    const emailInput = document.querySelector("input[name='email_acompanhamento']")
    const email = emailInput?.value?.trim()
    const msgEl = document.getElementById("msg_acompanhamento")

    if (!email) {
      this.#showMsg(msgEl, "Informe um e-mail.", "error")
      return
    }

    const res = await this.#post(this.enviarUrlValue, { email })
    this.#showMsg(msgEl, res.mensagem, res.ok ? "success" : "error")
    if (res.ok) setTimeout(() => document.getElementById("modal_acompanhamento").close(), 2000)
  }

  async enviarWhatsapp() {
    const msgEl = document.getElementById("msg_acompanhamento_whatsapp")

    const res = await fetch(this.enviarUrlValue.replace("enviar_link_acompanhamento", "gerar_link_acompanhamento_whatsapp"), {
      headers: { "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content }
    })
    const data = await res.json()

    if (data.ok) {
      const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(data.mensagem)}`
      window.open(whatsappUrl, "_blank")
      document.getElementById("modal_acompanhamento_whatsapp").close()
    } else {
      this.#showMsg(msgEl, data.mensagem, "error")
    }
  }

  async revogar() {
    if (!confirm("Deseja revogar o link de acompanhamento?")) return

    const res = await fetch(this.revogarUrlValue, {
      method: "DELETE",
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content,
        "Content-Type": "application/json"
      }
    })
    const data = await res.json()
    if (data.ok) window.location.reload()
  }

  async #post(url, body) {
    const res = await fetch(url, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    })
    return res.json()
  }

  #showMsg(el, text, type) {
    el.textContent = text
    el.className = `text-sm ${type === "success" ? "text-green-600" : "text-red-600"}`
    el.classList.remove("hidden")
  }
}
